import { IFieldValues } from "../model";

export const initialValues = {
  isDeleted: false,
};
